<div id="elevaagendaedu">
  <eae-header-navigation href=""></eae-header-navigation>
  <main>
    <P>
      <img src="assets/img/failed.png">
    </P>
    <h1>Erro {{ status ? status : 500 }}!</h1>
    <p *ngIf="!error">Erro no servidor</p>
    <p>{{error}}</p>
  </main>
</div>
